// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"759fb7e5","425":"0138126b","795":"2327416d"}[chunkId] + ".chunk.js";
};